import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinpune() {



  const cardData =
  {
    keyword: 'Tempo Traveller On Rent in Pune ',
    heading: 'Sanavi Travels: Tempo Traveller On Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable Tempo Traveller on Rent in Pune, providing safe, comfortable, and hassle-free travel solutions for families, corporate groups, tour operators, wedding parties, and large groups. Our fleet of well-maintained 9, 12, 13, 17, and 20 seater tempo travellers is ideal for local sightseeing, outstation trips, corporate events, and group travel from Pune. With spacious seating, ample luggage space, air-conditioned interiors, and experienced chauffeurs, Sanavi Travels ensures a smooth and enjoyable journey every time. We offer flexible rental options, transparent pricing, one-way and round-trip services, and 24/7 booking support, making us a trusted choice for tempo traveller rental in Pune. From city areas like Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, and Pimpri-Chinchwad to outstation destinations across Maharashtra and beyond, Sanavi Travels provides dependable Tempo Traveller on Rent in Pune for customers seeking comfort, safety, and reliable group transportation.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


    "topPlaces": [
      {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
      },
      {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
      },
      {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
      },
      {
        "title": "Sinhagad Fort",
        "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
      },
      {
        "title": "Pataleshwar Cave Temple",
        "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
      },
      {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
      },
      {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
      },
      {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
      },
      {
        "title": "Pu La Deshpande Garden",
        "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
      },
      {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
      }
    ],




    "services": [
      {
        "name": "Tempo Traveller On Rent in Pune",
        "description": "Tempo Traveller On Rent in Pune offers convenient self-drive or chauffeur-driven rental options for groups traveling within or around Pune. Ideal for family trips, corporate outings, and group tours, ensuring comfortable seating and reliable service."
      },
      {
        "name": "Tempo Traveller Hire Pune",
        "description": "Tempo Traveller Hire Pune provides flexible rental services for short or long journeys. Passengers benefit from well-maintained vehicles, professional drivers, and customizable travel plans for city tours or outstation trips."
      },
      {
        "name": "Tempo Traveller Rental Service Pune",
        "description": "Tempo Traveller Rental Service Pune specializes in renting spacious and comfortable vehicles for group travel. Perfect for sightseeing, family vacations, and corporate travel with emphasis on safety and punctuality."
      },
      {
        "name": "AC Tempo Traveller Pune",
        "description": "AC Tempo Traveller Pune offers air-conditioned vehicles for comfortable travel in Pune’s climate. Ideal for family trips, corporate outings, and long-distance journeys, ensuring a cool and relaxing ride."
      },
      {
        "name": "Luxury Tempo Traveller Pune",
        "description": "Luxury Tempo Traveller Pune provides premium, well-appointed vehicles with enhanced comfort and amenities. Perfect for VIP travel, weddings, or corporate events, combining elegance with convenience."
      },
      {
        "name": "Tempo Traveller for Outstation Pune",
        "description": "Tempo Traveller for Outstation Pune caters to travelers planning long-distance trips from Pune. With experienced drivers, spacious seating, and luggage-friendly vehicles, this service ensures safe and hassle-free outstation travel."
      },
      {
        "name": "Tempo Traveller for Family Tour Pune",
        "description": "Tempo Traveller for Family Tour Pune is designed for family vacations, offering ample space, comfort, and safety. Ideal for multi-day trips, sightseeing tours, or weekend getaways with children and seniors."
      },
      {
        "name": "Corporate Tempo Traveller Pune",
        "description": "Corporate Tempo Traveller Pune serves business travelers and office groups with punctual, comfortable, and professional transport solutions. Optional billing and route customization make it perfect for corporate needs."
      },
      {
        "name": "Tempo Traveller for Wedding Pune",
        "description": "Tempo Traveller for Wedding Pune provides stylish and spacious vehicles to transport wedding guests comfortably. Suitable for pre-wedding functions, ceremonies, and group transfers with premium service."
      },
      {
        "name": "Tempo Traveller Airport Transfer Pune",
        "description": "Tempo Traveller Airport Transfer Pune ensures timely pickups and drop-offs at airports for groups. With professional chauffeurs and luggage-friendly vehicles, passengers enjoy a smooth and convenient transfer experience."
      },
      {
        "name": "Affordable Tempo Traveller Pune",
        "description": "Affordable Tempo Traveller Pune offers budget-friendly rental options without compromising on comfort or safety. Ideal for groups seeking economical yet reliable travel within Pune and surrounding areas."
      },
      {
        "name": "Chauffeur Driven Tempo Traveller Pune",
        "description": "Chauffeur Driven Tempo Traveller Pune provides skilled drivers for hassle-free group travel. Passengers can relax while traveling safely to destinations in Pune or for outstation trips."
      },
      {
        "name": "Tempo Traveller Group Travel Pune",
        "description": "Tempo Traveller Group Travel Pune caters to large groups needing comfortable, spacious vehicles. Perfect for excursions, corporate outings, family trips, and long-distance journeys."
      },
      {
        "name": "Best Tempo Traveller in Pune",
        "description": "Best Tempo Traveller in Pune offers top-quality vehicles and professional service for a superior travel experience. Known for punctuality, comfort, and reliability for all types of group travel."
      },
      {
        "name": "Pune Tempo Traveller Booking",
        "description": "Pune Tempo Traveller Booking provides easy online and offline booking options for renting Tempo Travellers. Ensures flexible scheduling, transparent pricing, and reliable service for any travel requirement."
      }
    ],
    "tableData": [
      ["Tempo Traveller On Rent in Pune", "Tempo Traveller Hire Pune"],
      ["Tempo Traveller Rental Service Pune", "AC Tempo Traveller Pune"],
      ["Luxury Tempo Traveller Pune", "Tempo Traveller for Outstation Pune"],
      ["Tempo Traveller for Family Tour Pune", "Corporate Tempo Traveller Pune"],
      ["Tempo Traveller for Wedding Pune", "Tempo Traveller Airport Transfer Pune"],
      ["Affordable Tempo Traveller Pune", "Chauffeur Driven Tempo Traveller Pune"],
      ["Tempo Traveller Group Travel Pune", "Best Tempo Traveller in Pune"],
      ["Pune Tempo Traveller Booking", "—"]
    ],


    "whychoose": [
      {
        "WhyChooseheading": "Tempo Traveller on Rent in Pune with Sanavi Travels",
        "WhyChoosedescription": "Sanavi Travels offers reliable Tempo Traveller on rent in Pune, perfect for family trips, corporate travel, outstation tours, and group journeys."
      },
      {
        "WhyChooseheading": "Spacious and Comfortable Tempo Travellers",
        "WhyChoosedescription": "Travel comfortably in well-maintained, spacious, and air-conditioned Tempo Travellers designed for a smooth and relaxing group travel experience."
      },
      {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our skilled drivers are well-versed with Pune city and outstation routes, ensuring safe, punctual, and stress-free travel."
      },
      {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Tempo Traveller rentals in Pune, including fuel, driver charges, and tolls."
      },
      {
        "WhyChooseheading": "24/7 Customer Support",
        "WhyChoosedescription": "Our customer support team is available round the clock to help with bookings, itinerary planning, and travel assistance."
      },
      {
        "WhyChooseheading": "Flexible Rental Plans",
        "WhyChoosedescription": "Choose from local rentals, outstation trips, or customized Tempo Traveller rental plans based on your travel needs."
      },
      {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic journey."
      },
      {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Tempo Traveller on rent in Pune."
      }
    ]

  }

  const faqData = [
    {
      question: 'Does Sanavi Travels provide Tempo Traveller on rent in Pune?',
      answer: 'Yes, Sanavi Travels offers well-maintained Tempo Travellers on rent in Pune for local, outstation, and group travel.'
    },
    {
      question: 'How can I book a Tempo Traveller on rent in Pune with Sanavi Travels?',
      answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
    },
    {
      question: 'What seating options are available for Tempo Traveller rentals in Pune?',
      answer: 'We offer Tempo Travellers with multiple seating capacities suitable for small and large groups.'
    },
    {
      question: 'Are drivers provided with the Tempo Traveller rental?',
      answer: 'Yes, all Tempo Traveller rentals include experienced and professional drivers.'
    },
    {
      question: 'Can I book a Tempo Traveller for outstation trips from Pune?',
      answer: 'Absolutely. Sanavi Travels provides Tempo Traveller rentals for both local Pune travel and outstation tours.'
    },
    {
      question: 'Is Tempo Traveller service available 24x7 in Pune?',
      answer: 'Yes, our Tempo Traveller rental service in Pune is available round the clock.'
    },
    {
      question: 'Are the Tempo Travellers sanitized before trips?',
      answer: 'Yes, all vehicles are sanitized and cleaned thoroughly before every journey.'
    },
    {
      question: 'What payment options are available for Tempo Traveller bookings?',
      answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
    },
    {
      question: 'Is customer support available during the trip?',
      answer: 'Yes, our 24x7 customer support team is available throughout your journey.'
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: 'Mr. Rahul Patil',
      feedback: 'Booked a Tempo Traveller on rent in Pune from Sanavi Travels for a family trip. Very comfortable vehicle and professional driver.',
      rating: 5
    },
    {
      id: 2,
      name: 'Ms. Neha Joshi',
      feedback: 'Excellent service by Sanavi Travels. Clean Tempo Traveller, on-time pickup, and smooth journey.',
      rating: 5
    }
  ];


















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent in Pune - Sanavi Travels",
  "description": "Tempo Traveller on rent in Pune by Sanavi Travels. AC and luxury tempo traveller hire in Pune for outstation trips, family tours, corporate travel, weddings, airport transfers, and group travel. Affordable chauffeur-driven tempo traveller rental service in Pune with best comfort and safety."
};




  return (
    <div>
<Helmet>
  <title>
    Tempo Traveller On Rent in Pune | AC & Luxury Tempo Traveller Hire Pune – Sanavi Travels
  </title>

  <meta
    name="description"
    content="Tempo Traveller on rent in Pune by Sanavi Travels. AC and luxury tempo traveller hire in Pune for outstation trips, family tours, corporate travel, weddings, airport transfers, and group travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentinpune;